import { Link, Text } from 'platform-components';
import React from 'react';

import { useRegistrationLinkMetrika } from 'common.components/user/hooks';

import AddButton from '../__add-button/class__add-button';

interface ClassStudentsBadLinkProps {
    onClick: () => void;
}

export const ClassStudentsAddManually = ({ onClick }: ClassStudentsBadLinkProps) => {
    const { ymTeacherBadLink } = useRegistrationLinkMetrika();

    const handleClick = () => {
        ymTeacherBadLink('my_classes');
        onClick();
    };

    return (
        <AddButton mix="class__students-add-button" onClick={handleClick} withoutColor>
            <Text id="studentLinkBlock.cantInviteByLink" />
            <Link isRouter mix="class__invite-student-link" onClick={handleClick} pseudo theme={Link.THEME.PRIMARY}>
                <Text id="studentLinkBlock.goToManualAdding" weight={Text.WEIGHT.M} />
            </Link>
        </AddButton>
    );
};
